import FundVisibilityToggle from './FundVisibilityToggle'

export default FundVisibilityToggle
